import { getContent, replaceParams, getTrans } from './instantLoaded/tools';
import coreStore from '@/stores/core';
import sessionStore from '@/stores/session';
import { USING_IS_STYLE } from '@/types/General';
import { DIALOGUE_TYPE } from '@/types/common';
import {
  TFEOrderUserType,
  TFE_ORDER_TABS_SELLER_OFFSET,
  TFE_ORDER_VALUE_OF_TABALL,
  TFE_ORDER_VALUE_OF_TABRETURN,
  BUYER_TABS,
  SELLER_TABS,
  ChatbotComponentType,
  TFECardSelectionType,
  OrderType,
  OrderStyleInOrderWithHqs,
  OrderSelectorButtonType,
  OrderSelectorQueryOrderType,
  FlexDirection,
  SELECT_GROUP_ORDER_TEXT,
  CHECK_ANOTHER_ORDER_TEXT,
  MY_ORDER_TEXT,
  CLICK_HERE_TEXT,
  NewHotQuestionDisplayType,
} from '@/utils/constants';
import { IntentSource } from '@/types/intent';
import { isBank, isDriver } from '@/config/core';
import { isDelayShowIntentSelector } from '@/components/ChatbotUI/PropsProtocol/OrderListIntentSelector';
import { IsAnyLiveAgentAvailableEnum } from '@/services';
import { FEATURE_TOGGLE_TYPE, featureToggle } from './featureToggleConfig';
import { shouldReportLiveAgentForNoAgent } from './shouldReportLiveAgentForNoAgent';

export const REPLY_TYPE = {
  MSG: 1,
  ARTICLE: 2,
  OPTION: 3,
  FEEDBACK: 4,
  REDIRECTION: 5,
  LIVE: 6,
  ORDER_LIST: 7,
  QA_BUTTON: 8,
  TO_LOGIN: 9,
  GENERAL_BTN: 10,
  DIRECTLY_REDIRECTION: 11,
  RR_REQUEST_INFO: 12,
  BUTTON_FOR_TASKBOT_HORIZONTAL: 13,
  FEEDBACK_OPTIONS: 14,
  TRANSACTION: 15,
  ORDER_HOTQUESTIONS: 16,
  HOTQUESTIONS: 17,
  ANNOUNCEMENT: 18,
  ENQUIRY_DETAILS: 19,
  // 这个类型暂时只在历史消息中有
  DATE_TIME: 20,
  INTENT_HOT_QUESTION: 21,
  HOT_QUESTION_CATEGORY: 22,
  NEW_HOT_QUESTION: 23,
  ORDER_CARD: 24,
  SPLATER: 25,
  MY_SUPPORT_CASE: 26,
  INTENT_SELECTOR: 28,
  IMAGE: 29,
  NEW_QA_BUTTON: 30, // 新的qa类型，里面包含的intent可能是qa或task等
  SELECT_ORDER: 31,
  EPOD_IMAGE: 32, // add epod type
  ORDER_TIP_MSG: 33,
  ORDER_SELECTION_FAQ: 34,
  RR_HOTQUESTIONS: 35,
  ORDER_CARD_WITH_BUTTON: 36, // check rr repeated session
  CASE_CARD: 37, // inhouse case card
  FOOD_ORDER_CARD_WITH_BUTTON: 38,
  ORDER_SELECTOR: 40,
  PROBING_FORM_PREVIEW: 39,
  HOTQUESTION_WITH_MORE_ORDER: 41,
  CHANNEL_OPTION_LIVE: 42,
  ORDER_LIST_INTENT_SELECTOR: 43,
  ORDER_WITH_CONFIRMATION: 44,
  BASED_ACTION_HANDLE: 45,
  INTENT_CLARIFICATION: 2001, // Intent Clarification & Label Clarification

  // ======================
  // task flow editor 新增类型
  // ======================
  TFE_MESSAGE: 1001,
  TFE_BUTTON_SELECTOR: 1002,
  TFE_CARD_SELECTION: 1003,
  TFE_RELATED_INTENT: 1004,
  TFE_MODAL: 1005,
  TFE_OPTION_SELECTOR: 1006,
  TFE_ARTICLE: 1007,
  TFE_ORDER_TIP_MSG: 1010,
  TFE_ORDER_SELECTION_FAQ: 1011,
  TFE_EPOD_IMAGE: 1012,
  TFE_TIMELINE_CARD: 1013,
  TFE_BUYER_ORDER: 1014,
  TFE_BUYER_ORDER_LIST: 1015,
  KEY_ANSWER: 1016,
  TFE_CONTACT_COURIER_CARD: 1017,
  TFE_MULTIPLE_WEBFORM_NEW_API: 4001, // 使用在 webform 的 一个占位的 reply type

  EXPEDITE_DELIVERY_CARD: 1019, // 催促投递成功卡片
};

export const TFEMessageUIType = {
  default: 0,
  new: 1,
};

const generateMsgContent = (message) => {
  const { text_extra } = message;
  let realContent = getContent(message);
  if (text_extra) {
    realContent = replaceParams(realContent, text_extra);
  }
  return realContent || '';
};

const DELAY_SHOW_FAQ_GROUP = 'delay_display';
const SHOW_VIEW_MORE_FAQ_GROUP = 'view_more_faq';
const isDelayShowFAQ = (expConfig) => {
  const expGroup = expConfig?.article_faq_rcmd_ui?.group;
  return expGroup === DELAY_SHOW_FAQ_GROUP || expGroup === SHOW_VIEW_MORE_FAQ_GROUP;
};
const checkHaveAccordion = (html) => {
  if (!html || typeof html !== 'string') {
    return false;
  }
  return /<accordion-block/.test(html);
};

export default {
  // 纯文本消息，消息体为空
  [REPLY_TYPE.MSG]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const content = generateMsgContent(dialogue.message);

    if (!content) {
      return;
    }

    const extraInfo = dialogue.message_extra || {};
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Msg,
      data: {
        id: dialogue?.message?.message_id,
        content,
        isKbRichText: dialogue?.message?.is_rich_text,
        kbIntentId: extraInfo.text_intent_info?.kb_intent_id,
        kbBotId: extraInfo.text_intent_info?.kb_bot_id,
        haveMinWidth: checkHaveAccordion(content),
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.ORDER_LIST_INTENT_SELECTOR]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
    isHistory,
  ) => {
    const content = generateMsgContent(dialogue.message);

    const extraInfo = dialogue.message_extra || {};
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderListIntentSelector,
      hidden: !isHistory && isDelayShowIntentSelector(extraInfo.recommend_display_type),
      data: {
        id: dialogue?.message?.message_id,
        content,
        displayType: extraInfo.recommend_display_type,
        intents: extraInfo.recommend_intents,
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        extraInfo,
      },
    };

    return dialogueContent;
  },
  // 消息带一or多篇文章
  [REPLY_TYPE.ARTICLE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req, isHistory) => {
    const extraInfo = dialogue.message_extra || {};
    const articles = extraInfo.articles;

    // 记录展示的article的id
    articles.forEach((item) => {
      sessionStore.ADD_SHOWED_ARTICLE(item.article_number);
    });

    let dialogueContent = {};

    if (articles.length === 1) {
      const article = articles[0];
      dialogueContent = {
        nodePointId: node_point_id,
        dialogueId: dialogue_id,
        dialogueType: dialogue_type,
        from: 'bot',
        type: DIALOGUE_TYPE.SingleArticle,
        data: {
          id: dialogue?.message?.message_id,
          article,
          content: article.content,
          article_number: article.article_number,
          title: article.title,
          button_id: article.button_id,
          button_type: article.button_type,
          kb_bot_id: article.kb_bot_id,
          url_name: article.url_name,
          kb_intent_id: article.kb_intent_id,
          kb_edition: article.kb_edition,
          kb_answer_id: article.kb_answer_id,
          needOpen: featureToggle.getFeatureEnable(FEATURE_TOGGLE_TYPE.UI_OPTIMISATION_ARTICLE) && featureToggle.getFeatureEnable(FEATURE_TOGGLE_TYPE.UI_OPTIMISATION_ARTICLE_AUTO_POPUP),
          shouldDisplayInstantly: article?.should_display_instantly, // 文章的是否自动弹出取决于文章should_display_instantly字段
          showRCMDOnClose: !isHistory && isDelayShowFAQ(extraInfo.exp_config),
        },
      };
    } else {
      dialogueContent = {
        nodePointId: node_point_id,
        dialogueId: dialogue_id,
        dialogueType: dialogue_type,
        from: 'bot',
        type: DIALOGUE_TYPE.MultiArticle,
        data: {
          id: dialogue?.message?.message_id,
          msgContent: generateMsgContent(dialogue.message),
          articleList: articles,
        },
      };
    }

    return dialogueContent;
  },
  // 消息带taskbot点击的按钮
  [REPLY_TYPE.OPTION]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const order_id = req?.params?.message_extra?.params?.order_id || '';
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Options,
      data: {
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        options: dialogue.message_extra.buttons_for_taskbot,
        context: { order_id },
      },
    };

    return dialogueContent;
  },
  // 消息带feedback的按钮
  [REPLY_TYPE.FEEDBACK]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Feedback,
      data: {
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        options: dialogue.message_extra.buttons_for_feedback,
      },
      callback: (curPos) => {
        sessionStore.UPDATE_CUR_FEEDBACK({
          dialogue_id,
          curPos, // addDialogue返回的index
        });
      },
    };

    return dialogueContent;
  },
  // 消息带可以跳转的按钮
  [REPLY_TYPE.REDIRECTION]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Redirection,
      data: {
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        buttons: dialogue.message_extra.buttons_for_redirection,
      },
    };

    return dialogueContent;
  },
  // 消息带转人工按钮
  [REPLY_TYPE.LIVE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id }, req, isHistory) => {
    const buttonsForLive = dialogue.message_extra.buttons_for_live;
    const live_agent_pre_check_inbound = dialogue.message_extra?.live_agent_pre_check_inbound;
    const live_chat_pre_check_inbound = live_agent_pre_check_inbound?.live_chat_pre_check_inbound;
    const virtual_call_pre_check_inbound = live_agent_pre_check_inbound?.virtual_call_pre_check_inbound;
    shouldReportLiveAgentForNoAgent(
      !(live_chat_pre_check_inbound || virtual_call_pre_check_inbound),
    );
    if (buttonsForLive.length === 2) {
      const data = dialogue.message_extra.buttons_for_live || {};
      const btnCaseData = data[0] || {};
      const btnLiveData = data[1] || {};

      const dialogueContent = {
        nodePointId: node_point_id,
        dialogueId: dialogue_id,
        dialogueType: dialogue_type,
        from: 'bot',
        type: DIALOGUE_TYPE.Live,
        data: {
          id: dialogue?.message?.message_id,
          msgContent: generateMsgContent(dialogue.message),
          btnContent: [getContent(btnCaseData), getContent(btnLiveData)],
          queue_name: [btnCaseData.queue_name || '', btnLiveData.queue_name || ''],
          buttonType: [btnCaseData.button_type || '', btnLiveData.button_type || ''],
          buttonId: [btnCaseData.button_id || '', btnLiveData.button_id || ''],
          user_type: [btnCaseData.user_type_id || '', btnLiveData.user_type_id || ''],
          enquiry_type: [btnCaseData.enquiry_type_id || '', btnLiveData.enquiry_type_id || ''],
          liveAgentAutoQueueInfo: dialogue?.message_extra?.live_agent_auto_queue_info || {},
          isKbRichText: dialogue?.message?.is_rich_text,
          isCaseSelect: true,
          isButtonsDisabled: false,
          // enquiryCaseNum: btnCaseData.extra_param?.current_size > btnCaseData.extra_param?.max_size ? '20+' : String(btnCaseData.extra_param?.current_size),
          enquiryCaseCurSize: btnCaseData.extra_param?.current_size || 0,
          enquiryCaseMaxSize: btnCaseData.extra_param?.max_size || 0,
          kbBotId: kb_bot_id,
          live_agent_pre_check_inbound: {
            // default value: true
            live_chat_pre_check_inbound: !!(live_chat_pre_check_inbound ?? IsAnyLiveAgentAvailableEnum.Available),
            // default value: true
            virtual_call_pre_check_inbound: !!(virtual_call_pre_check_inbound ?? IsAnyLiveAgentAvailableEnum.Available),
          },
        },
      };

      (btnLiveData.extra_param?.return_sn || btnLiveData.extra_param?.return_id)
        && sessionStore.SET_ORDER_INFO_DATA({
          return_sn: btnLiveData.extra_param?.return_sn,
          return_id: btnLiveData.extra_param?.return_id,
        });

      if (btnLiveData.extra_param?.order_sn) {
        sessionStore.ADD_ORDER_SN(btnLiveData.extra_param.order_sn);
      }

      return dialogueContent;
    } else {
      const data = dialogue.message_extra.buttons_for_live[0] || {};

      const dialogueContent = {
        nodePointId: node_point_id,
        dialogueId: dialogue_id,
        dialogueType: dialogue_type,
        from: 'bot',
        type: DIALOGUE_TYPE.Live,
        data: {
          id: dialogue?.message?.message_id,
          msgContent: generateMsgContent(dialogue.message),
          btnContent: getContent(data),
          queue_name: data.queue_name || '',
          buttonType: data.button_type || '',
          buttonId: data.button_id || '',
          user_type: data.user_type_id,
          enquiry_type: data.enquiry_type_id,
          liveAgentAutoQueueInfo: dialogue?.message_extra?.live_agent_auto_queue_info || {},
          isKbRichText: dialogue?.message?.is_rich_text,
          live_agent_pre_check_inbound: {
            // default value: true
            live_chat_pre_check_inbound: !!(live_chat_pre_check_inbound ?? IsAnyLiveAgentAvailableEnum.Available),
            // default value: true
            virtual_call_pre_check_inbound: !!(virtual_call_pre_check_inbound ?? IsAnyLiveAgentAvailableEnum.Available),
          },
        },
      };

      (data.extra_param?.return_sn || data.extra_param?.return_id)
        && sessionStore.SET_ORDER_INFO_DATA({
          return_sn: data.extra_param?.return_sn,
          return_id: data.extra_param?.return_id,
        });

      if (data.extra_param?.order_sn) {
        sessionStore.ADD_ORDER_SN(data.extra_param.order_sn);
      }

      return dialogueContent;
    }
  },
  // 消息带订单信息
  [REPLY_TYPE.ORDER_LIST]: (
    { dialogue_id, dialogue_type, dialogue, taskbot_name, node_point_id = '' },
    req,
    isHistory,
  ) => {
    const {
      node_id,
      has_more = 0,
      is_seller = false,
      show_type,
      order_list = [],
      more_button_type,
      more_button_id,
      has_faq = false,
      faq_node_id = '',
      ext_key_value = {},
      order_card_type,
      more_button_text,
      select_order_button_text,
      is_order_shortcut,
      order_selection_scene,
    } = dialogue.message_extra.order_info;

    coreStore.safeGetStore('userStore').UPDATE_IS_SELLER(is_seller);
    const { sessionId } = coreStore.safeGetStore('initStore');

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      roundId: dialogue?.message_extra?.round_id,
      type: DIALOGUE_TYPE.TFEOrderList,
      data: {
        taskbotName: taskbot_name,
        id: dialogue?.message?.message_id,
        node_id,
        order_list,
        is_seller,
        show_type,
        sessionId,
        moreButtonType: more_button_type,
        moreButtonId: more_button_id,
        has_faq,
        faq_node_id,
        ext_key_value,
        showMoreOrderButton: has_more,
        maxDisplay: Number.MAX_SAFE_INTEGER,
        orderCardType: order_card_type,
        chatbotComponentType: ChatbotComponentType.OldChatbot,
        moreButtonText: more_button_text,
        selectOrderButtonText: select_order_button_text,
        isShortcutOrder: is_order_shortcut,
        orderSelectionScene: order_selection_scene,
        shouldDisplayInstantly: true,
        delayDisplayRecommendIntentSelector:
          !isHistory && isDelayShowIntentSelector(dialogue.message_extra.recommend_display_type),
      },
    };

    return dialogueContent;
  },
  // QAbot多篇文章
  [REPLY_TYPE.QA_BUTTON]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const extraInfo = dialogue.message_extra || {};
    const buttons = extraInfo.buttons_for_qabot;
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.QAButton,
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        buttons,
      },
    };

    return dialogueContent;
  },
  // 需要登录
  [REPLY_TYPE.TO_LOGIN]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    coreStore.safeGetStore('userStore').UPDATE_DATA({});
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Login,
      data: {
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        button: dialogue.message_extra.buttons_for_login[0] || {},
        req,
      },
    };

    return dialogueContent;
  },
  // 通用按钮
  [REPLY_TYPE.GENERAL_BTN]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '', taskbot_name }, req) => {
    const order_id = req?.params?.message_extra?.params?.order_id || '';
    const using_is_style = dialogue.message_extra.using_is_style ? USING_IS_STYLE.YES : USING_IS_STYLE.NO;
    const dataGeneral = dialogue.message_extra.buttons_for_general || [];

    const dialogueContent = {
      taskbotName: taskbot_name,
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.General,
      data: {
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        options: dialogue.message_extra.buttons_for_general,
        usingIsStyle: using_is_style,
        context: { order_id },
      },
    };

    dataGeneral.forEach((item) => {
      if (item.button_type === 'btn_live') {
        (item.extra_param?.return_sn || item.extra_param?.return_id)
          && sessionStore.SET_ORDER_INFO_DATA({
            return_sn: item.extra_param?.return_sn,
            return_id: item.extra_param?.return_id,
          });
        item.extra_param?.order_sn && sessionStore.ADD_ORDER_SN(item.extra_param.order_sn);
      }
      if (item.button_type === 'btn_taskbot') {
        const copiedSessionStoreInfo = { ...sessionStore.orderInfo };
        const { returnID, returnSN } = copiedSessionStoreInfo;
        sessionStore.SET_ORDER_INFO_DATA({
          order_id: item.extra_param?.order_id,
          return_id: returnID,
          return_sn: returnSN,
        });
      }
    });

    return dialogueContent;
  },
  // 直接重定向
  [REPLY_TYPE.DIRECTLY_REDIRECTION]: ({ dialogue_id, dialogue_type, dialogue }) => {
    const option = dialogue.message_extra;
    // 延迟跳转，为了不影响后续消息渲染
    setTimeout(() => {
      // @MARK: lazyLoad: { handleRedirectionBtnClick }
      import('@/utils/btnClickHandler').then(({ handleRedirectionBtnClick }) => {
        handleRedirectionBtnClick(option, null, () => {
          // @MARK: lazyLoad: { handleRedirectBack }
          import('./tools').then(({ handleRedirectBack }) => {
            handleRedirectBack(option, { dialogueId: dialogue_id });
          });
        });
      });
    }, 600);
  },

  // RR 订单信息
  [REPLY_TYPE.RR_REQUEST_INFO]: ({ dialogue_id, dialogue_type, dialogue, taskbot_name, node_point_id = '' }, req) => {
    const {
      node_id,
      has_more = 0,
      is_seller = false,
      rr_request_list = [],
      more_button_type,
      more_button_id,
      has_faq = false,
      faq_node_id = '',
      ext_key_value = {},
      order_card_type,
    } = dialogue.message_extra.rr_request_info;

    coreStore.safeGetStore('userStore').UPDATE_IS_SELLER(is_seller);
    const { sessionId } = coreStore.safeGetStore('initStore');

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.TFEOrderList,
      data: {
        taskbotName: taskbot_name,
        id: dialogue?.message?.message_id,
        sessionId,
        node_id,
        has_more,
        order_list: rr_request_list,
        is_seller,
        isForRR: true,
        moreButtonType: more_button_type,
        moreButtonId: more_button_id,
        has_faq,
        faq_node_id,
        ext_key_value,
        orderCardType: order_card_type,
        showMoreOrderButton: has_more,
        maxDisplay: Number.MAX_SAFE_INTEGER,
        chatbotComponentType: ChatbotComponentType.OldChatbot,
      },
    };

    return dialogueContent;
  },
  // 横向按钮
  [REPLY_TYPE.BUTTON_FOR_TASKBOT_HORIZONTAL]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Options,
      data: {
        id: dialogue?.message?.message_id,
        type: 'horizontal',
        msgContent: generateMsgContent(dialogue.message),
        options: dialogue.message_extra.buttons_for_taskbot,
      },
    };

    return dialogueContent;
  },
  // Feedback的反馈
  [REPLY_TYPE.FEEDBACK_OPTIONS]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const dataGeneral = dialogue.message_extra.buttons_for_general || [];

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.NegativeOptions,
      data: {
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        options: dialogue.message_extra.feedback_options || [],
        buttons: dialogue.message_extra.buttons_for_general || [],
      },
    };

    dataGeneral.forEach((item) => {
      if (item.button_type === 'btn_live') {
        (item.extra_param?.return_sn || item.extra_param?.return_id)
          && sessionStore.SET_ORDER_INFO_DATA({
            return_sn: item.extra_param?.return_sn,
            return_id: item.extra_param?.return_id,
          });
        item.extra_param?.order_sn && sessionStore.ADD_ORDER_SN(item.extra_param.order_sn);
      }
    });

    return dialogueContent;
  },

  [REPLY_TYPE.TRANSACTION]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const {
      node_id,
      has_more = 0,
      type,
      list = [],
      more_button_type,
      more_button_id,
    } = dialogue?.message_extra?.transactions || {};

    const [buttons_chat_main_location = {}, buttons_chat_vice_location = {}]
      = dialogue?.message_extra?.buttons_for_general || [];
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.StateTransactionList,
      data: {
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        node_id,
        has_more,
        type,
        list,
        buttons_chat_main_location: {
          ...buttons_chat_main_location,
          message: getContent(buttons_chat_main_location),
        },
        buttons_chat_vice_location: {
          ...buttons_chat_vice_location,
          message: getContent(buttons_chat_vice_location),
        },
        moreButtonType: more_button_type,
        moreButtonId: more_button_id,
      },
    };

    return dialogueContent;
  },
  // 带有order信息的hot question
  [REPLY_TYPE.ORDER_HOTQUESTIONS]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const intents = dialogue?.message_extra?.specific_hot_questions?.intent_hot_questions || [];
    const order = dialogue?.message_extra?.specific_hot_questions?.order || {};
    const orderStyle = dialogue?.message_extra?.specific_hot_questions?.order_style || {};
    const otherFrequentlyAsked = dialogue?.message_extra?.extra_buttons?.hot_question_buttons?.[0];
    const { sessionId } = coreStore.safeGetStore('initStore');

    let dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
    };

    switch (orderStyle) {
      case OrderStyleInOrderWithHqs.order_detail:
        dialogueContent = {
          ...dialogueContent,
          type: DIALOGUE_TYPE.OrderCardWithButton,
          data: {
            kbBotId: kb_bot_id,
            kbBotName: kb_bot_name,
            order,
            fromType: dialogue?.message_extra?.from_type,
            intents: intents,
            sessionId,
            orderType: OrderType.orderWithHotQuestion,
            otherFrequentlyAsked,
            enableMinimiseCategoryUI: true,
          },
        };
        break;

      default:
        dialogueContent = {
          ...dialogueContent,
          type: DIALOGUE_TYPE.OrderCardWithHQ,
          data: {
            kbBotId: kb_bot_id,
            kbBotName: kb_bot_name,
            hotQuestions: intents,
            order,
            otherFrequentlyAsked,
          },
        };
    }

    (order?.return_sn || order?.return_id)
      && sessionStore.SET_ORDER_INFO_DATA({
        return_sn: order?.return_sn,
        return_id: order?.return_id,
      });

    if (order.order_sn) {
      sessionStore.ADD_ORDER_SN(order.order_sn);
    }

    return dialogueContent;
  },
  // 正常的hot question
  [REPLY_TYPE.HOTQUESTIONS]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const content = getContent(dialogue.message);
    const { message_extra: { hot_questions }} = dialogue;
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.HotQuestions,
      data: {
        hotQuestionList: hot_questions,
        msgContent: content,
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.ANNOUNCEMENT]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const { message_extra: { announcements, popup_announcement }} = dialogue;
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Announcements,
      data: { announcementList: announcements, popupAnnouncement: popup_announcement },
      highZIndex: true,
    };
    if (announcements?.length) {
      return dialogueContent;
    }
  },

  [REPLY_TYPE.ENQUIRY_DETAILS]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '' },
    req,
    needReturn = false,
  ) => {
    const { button_and_title_for_live } = dialogue.message_extra;
    const footer = getContent(button_and_title_for_live.footer);

    const dialogContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.EnquiryDetails,
      data: {
        title: getContent(button_and_title_for_live.title),
        content: getContent(button_and_title_for_live.content),
        footer: getContent(footer),
        clickParams: [{ dialogueId: dialogue_id, dialogueType: dialogue_type, text: footer }, false],
      },
    };

    if (needReturn) {
      return dialogContent;
    }
    // @MARK: lazyLoad: { getEnquiryInfo }
    import('@/utils/btnClickHandler').then(({ getEnquiryInfo }) => {
      getEnquiryInfo(
        { dialogueId: dialogue_id, dialogueType: dialogue_type, text: footer, needCheckLogin: true },
        false,
      );
    });
    return dialogContent;
  },
  [REPLY_TYPE.DATE_TIME]: ({ dialogue_id, dialogue_type, dialogue, sendTime, node_point_id = '' }, req) => {
    if (!sendTime) {
      return;
    }

    // 这个类型暂时只在历史消息中有
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'system',
      type: DIALOGUE_TYPE.DateTime,
      data: { time: sendTime },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.INTENT_HOT_QUESTION]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const {
      message,
      message_extra: { next_head_intents = [], order, display_type = 0 },
    } = dialogue;
    const otherFrequentlyAsked = dialogue?.message_extra?.extra_buttons?.hot_question_buttons?.[0];

    const content = getContent(message);

    sessionStore.UPDATE_INTENT_HOT_QUESTION(next_head_intents || []);

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.IntentHotQuestion,
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        msgContent: content,
        order,
        hotQuestions: next_head_intents || [],
        displayType: display_type,
        otherFrequentlyAsked,
      },
    };
    return dialogueContent;
  },

  [REPLY_TYPE.HOT_QUESTION_CATEGORY]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const { message_extra } = dialogue;
    const { categories = [], display_type = 0 } = message_extra;

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.HotQuestionCategory,
      data: {
        categories: categories || [],
        flexDirection: isDriver() ? FlexDirection.Row : FlexDirection.Column,
        displayType: display_type,
      },
    };
    return dialogueContent;
  },

  [REPLY_TYPE.NEW_HOT_QUESTION]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
    isHistory,
  ) => {
    const { message, message_extra } = dialogue;
    const {
      cat_intent_list: { intents, category_name, source },
      buttons_for_live,
      category_addition_info = '',
      exp_config,
      display_type,
    } = message_extra;

    const content = getContent(message);
    const originDialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.NewHotQuestion,
      hidden: !isHistory && isDelayShowFAQ(exp_config),
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        msgContent: content,
        msgPrefix: category_addition_info,
        categoryName: category_name,
        hotQuestions: (intents ?? []).map((i) => ({
          id: i.intent_id,
          text: i.hotquestion_text,
          intentType: i.intent_type,
          queryCallback: i.query_callback,
          categoryName: category_name,
          intentSource: i.intent_source,
        })),
        source: source || 0,
        showViewMore: exp_config?.article_faq_rcmd_ui?.group === SHOW_VIEW_MORE_FAQ_GROUP,
        isMinimiseCategoryUI: featureToggle.getFeatureEnable(FEATURE_TOGGLE_TYPE.UI_OPTIMISATION_MINIMISE_CATEGORY_HOT_QUESTION, display_type, source),
        isMinimiseCategoryHotQuestion: featureToggle.getFeatureEnable(FEATURE_TOGGLE_TYPE.UI_OPTIMISATION_MINIMISE_CATEGORY_HOT_QUESTION, display_type, source),
      },
    };

    const hasLiveAgent = source === IntentSource.LiveAgentRecommender;
    if (hasLiveAgent) {
      const { userType, enquiryType } = coreStore.safeGetStore('agentStore');

      const data = buttons_for_live[0] ?? {};
      const channelData = buttons_for_live.slice(1);

      return {
        ...originDialogueContent,
        type: DIALOGUE_TYPE.LiveAgentRecommender,
        data: {
          ...originDialogueContent.data,
          hasLiveAgent: true,
          // 一进入 chatbot 就触发 chat with agent，lastDialogueId 为空，则传递 currentDialogueId
          lastDialogueId: sessionStore.lastDialogueId || sessionStore.currentDialogueId,
          liveButtonInfo: {
            btnContent: getContent(data),
            buttonType: data.button_type || '',
            queue_name: enquiryType,
            user_type: userType,
            enquiry_type: enquiryType,
          },
          channelButtonInfos: channelData.map((v) => ({
            ...v,
            button_text: getContent(v),
          })),
        },
      };
    }

    return originDialogueContent;
  },

  [REPLY_TYPE.ORDER_CARD]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const { message_extra } = dialogue;

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderCardWithSN,
      data: { order: message_extra.order },
    };

    (message_extra?.order?.return_sn || message_extra?.order?.return_id)
      && sessionStore.SET_ORDER_INFO_DATA({
        return_sn: message_extra?.order?.return_sn,
        return_id: message_extra?.order?.return_id,
      });

    if (message_extra?.order?.order_sn) {
      sessionStore.ADD_ORDER_SN(message_extra?.order?.order_sn);
    }

    return dialogueContent;
  },
  // SPLater 消息类型
  [REPLY_TYPE.SPLATER]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const {
      message,
      message_extra: {
        list_display_option: { full_list_header_text, full_list_confirm_button, display_num, show_more_button },
        list_items = [],
      },
    } = dialogue;
    const title = getContent(message);
    const listTitle = getContent(full_list_header_text);
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.SPLater,
      data: {
        title,
        listTitle,
        listConfirmButton: full_list_confirm_button,
        displayNum: display_num,
        showMoreButton: show_more_button,
        listItems: list_items,
      },
    };
    return dialogueContent;
  },
  [REPLY_TYPE.MY_SUPPORT_CASE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const { message_extra: { support_case_display = {}}} = dialogue;
    const { support_case = {}, url = '' } = support_case_display;

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.MySupportCase,
      data: {
        id: dialogue?.message?.message_id,
        msgContent: getContent(dialogue.message),
        support_case,
        url,
      },
    };

    if (support_case?.total_count > 0) {
      return dialogueContent;
    }
  },
  [REPLY_TYPE.INTENT_SELECTOR]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const {
      message,
      message_extra: { is_intent_list: intentList = [] },
    } = dialogue;
    const question = getContent(message);

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.IntentSelector,
      data: {
        question,
        intentList,
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.IMAGE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Image,
      data: {
        id: dialogue?.message?.message_id,
        imgUrl: dialogue?.message_extra?.image_url,
        loading: false,
        isEpod: false,
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.EPOD_IMAGE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.Image,
      data: {
        id: dialogue?.message?.message_id,
        imgUrl: dialogue?.message_extra?.image_url,
        loading: false,
        isEpod: true,
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.NEW_QA_BUTTON]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const extraInfo = dialogue.message_extra || {};
    const { clarification_stage, thread_id, thread_node_id, thread_id_v2, round_id } = extraInfo;
    const buttons = extraInfo.cat_intent_list.intents.map((v) => ({ ...v, title: v.intent_name }));
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.QAButton,
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        id: dialogue?.message?.message_id,
        msgContent: generateMsgContent(dialogue.message),
        buttons,
        clarification_stage,
        thread_id,
        thread_node_id,
        thread_id_v2,
        round_id,
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.SELECT_ORDER]: ({ dialogue_id, dialogue_type, taskbot_name, dialogue, node_point_id = '' }, req) => {
    const data = dialogue.message_extra.order_info || {};
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: 'SelectOrder',
      data: {
        shouldDisplayInstantly: true,
        id: dialogue?.message?.message_id,
        taskbotName: taskbot_name,
        msgContent: generateMsgContent(dialogue.message),
        queue_name: data.queue_name || '',
        is_seller: data.is_seller,
        node_id: data.node_id || '',
        hasAnnouncement: dialogue.message_extra.has_announcement,
        buttonType: data.more_button_type || '',
        buttonId: data.more_button_id || '',
      },
    };
    coreStore.safeGetStore('userStore').UPDATE_IS_SELLER(data.is_seller);

    return dialogueContent;
  },
  [REPLY_TYPE.INTENT_CLARIFICATION]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const {
      message_extra: {
        clarification_stage,
        thread_id,
        thread_node_id,
        thread_id_v2,
        round_id,
        label_clarification: { content, options, clarification_version, gray_option },
      },
    } = dialogue;

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: 'IntentSelector',
      data: {
        gray_option,
        clarification_stage,
        thread_id,
        thread_node_id,
        thread_id_v2,
        round_id,
        clarification_version,
        question: content,
        isClarification: true,
        intentList: options.map((option) => ({
          id: option.option_id,
          intent_text: option.content,
          button_type: option.action.action_type,
          button_id: option.option_id,
          sub_intent_list: (
            option.sub_options || [
              {
                sub_option_id: option.option_id,
                content: option.content,
                action: option.action,
              },
            ]
          ).map((subOption) => ({
            sub_intent_node_point_id: subOption.sub_option_id,
            sub_intent_text: subOption.content,
            button_id: subOption.sub_option_id,
            button: {
              button_type: subOption.action.action_type,
              intent_base_action: subOption.action.action_param,
            },
          })),
        })),
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.KEY_ANSWER]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_name }, req) => {
    const { message_extra: { thread_id, thread_node_id, thread_id_v2, round_id, key_answer = {}}} = dialogue;

    const dialogContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.KeyAnswer,
      data: {
        id: dialogue?.message?.message_id,
        thread_id,
        thread_node_id,
        thread_id_v2,
        round_id,
        faqTitle: key_answer.faq_recommend ? getContent(key_answer.faq_recommend) : '',
        faqIntentList: key_answer.faq_recommend?.cat_intent_list?.intents?.map?.((faq) => ({
          ...faq,
          text: faq.hotquestion_text,
        })),
        summary: key_answer.summary,
        supportingMessage: key_answer.supporting_message,
        kbIntentId: key_answer?.kb_intent_id,
        kbAnswerId: key_answer?.kb_answer_id,
        kbEdition: key_answer?.kb_edition,
        kbBotId: key_answer?.kb_bot_id,
        kbBotName: kb_bot_name,
        source: key_answer?.faq_recommend?.cat_intent_list?.source,
      },
    };

    return dialogContent;
  },

  [REPLY_TYPE.ORDER_TIP_MSG]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const content = generateMsgContent(dialogue.message);

    if (!content) {
      return;
    }

    const buttons_for_taskbot = dialogue.message_extra.buttons_for_taskbot || [];
    const [button] = buttons_for_taskbot;

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderTipMsg,
      data: {
        id: dialogue?.message?.message_id,
        content,
        button,
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.ORDER_SELECTION_FAQ]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const {
      message,
      message_extra: {
        list_display_option: { full_list_header_text, full_list_confirm_button, display_num, show_more_button },
        list_items = [],
      },
    } = dialogue;
    const title = getContent(message);
    const listTitle = getContent(full_list_header_text);
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderSelectionFAQ,
      data: {
        title,
        listTitle,
        listConfirmButton: full_list_confirm_button,
        displayNum: display_num,
        showMoreButton: show_more_button,
        listItems: list_items?.map((item) => {
          const { node_id, button_id, ext_key_value } = item.button_for_taskbot || {};
          return {
            node_id,
            button_id: button_id,
            button_text: getContent(item.button_for_taskbot),
            intent_id: Number(ext_key_value?.IntentId), // 用于上报
            source_intent_id: Number(ext_key_value?.SourceIntentId),
            ext_key_value,
          };
        }),
      },
    };
    return dialogueContent;
  },

  [REPLY_TYPE.RR_HOTQUESTIONS]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const intents = dialogue?.message_extra?.specific_hot_questions?.intent_hot_questions || [];
    const order = dialogue?.message_extra?.specific_hot_questions?.order || {};
    const otherFrequentlyAsked = dialogue?.message_extra?.extra_buttons?.hot_question_buttons?.[0];
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderCardWithHQ,
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        hotQuestions: intents,
        order,
        isRR: true,
        otherFrequentlyAsked,
      },
    };

    if (order?.return_sn || order?.return_id) {
      sessionStore.SET_ORDER_INFO_DATA({
        return_sn: order?.return_sn,
        return_id: order?.return_id,
      });
    }

    if (order.order_sn) {
      sessionStore.ADD_ORDER_SN(order.order_sn);
    }

    return dialogueContent;
  },

  [REPLY_TYPE.ORDER_CARD_WITH_BUTTON]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const order = dialogue?.message_extra?.order || {};
    const repeatedSessionType = dialogue?.message_extra?.repeated_session_type;
    const buttons = dialogue?.message_extra?.buttons_for_general || [];
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderCardWithButton,
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        order,
        buttons,
        repeatedSessionType,
      },
    };

    if (order?.return_sn || order?.return_id) {
      sessionStore.SET_ORDER_INFO_DATA({
        return_sn: order?.return_sn,
        return_id: order?.return_id,
      });
    }

    if (order.order_sn) {
      sessionStore.ADD_ORDER_SN(order.order_sn);
    }

    return dialogueContent;
  },

  [REPLY_TYPE.FOOD_ORDER_CARD_WITH_BUTTON]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const order = dialogue?.message_extra?.shopee_food_driver_order_card || {};
    const buttons = dialogue?.message_extra?.buttons_for_general || [];
    const otherFrequentlyAsked = dialogue?.message_extra?.extra_buttons?.hot_question_buttons?.[0];
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderCardWithButton,
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        order,
        buttons,
        orderType: OrderType.food,
        otherFrequentlyAsked,
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.ORDER_SELECTOR]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const text = getContent(dialogue?.message);
    const btn = dialogue?.message_extra?.button_for_click_here?.[0] || {};
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderSelector,
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        orderType: OrderType.food,
        text,
        panelTitleText: getTrans(SELECT_GROUP_ORDER_TEXT),
        btn: {
          text_value: getContent(btn),
          callback_params: btn.callback_params,
          button_type: btn.button_style,
        },
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.HOTQUESTION_WITH_MORE_ORDER]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', kb_bot_id, kb_bot_name },
    req,
  ) => {
    const order = dialogue?.message_extra?.order || {};
    const repeatedSessionType = dialogue?.message_extra?.repeated_session_type;
    const buttons = dialogue?.message_extra?.buttons_for_general || [];
    const { sessionId } = coreStore.safeGetStore('initStore');
    const content = getContent(dialogue?.message);
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderCardWithButton,
      data: {
        kbBotId: kb_bot_id,
        kbBotName: kb_bot_name,
        cardTitle: getContent(dialogue?.message),
        order,
        fromType: dialogue?.message_extra?.from_type,
        buttons,
        repeatedSessionType,
        sessionId,
        orderType: OrderType.prediction,
        msgContent: content,
        shouldDisplayInstantly: true,
        separateMessage: dialogue?.message_extra?.separate_message_bubble,
        triggeredByOrderShortcut: dialogue?.message_extra?.is_trigger_by_order_shortcut,
      },
    };

    if (order?.return_sn || order?.return_id) {
      sessionStore.SET_ORDER_INFO_DATA({
        return_sn: order?.return_sn,
        return_id: order?.return_id,
      });
    }

    if (order.order_sn) {
      sessionStore.ADD_ORDER_SN(order.order_sn);
    }

    return dialogueContent;
  },

  [REPLY_TYPE.CHANNEL_OPTION_LIVE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const { message, message_extra } = dialogue;
    const { buttons_for_live } = message_extra;

    const data = buttons_for_live[0] ?? {};
    const channelData = buttons_for_live.slice(1);

    const { userType, enquiryType } = coreStore.safeGetStore('agentStore');
    return {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.ChannelOptionLive,
      data: {
        content: getContent(message),
        queue_name: enquiryType,
        user_type: userType,
        enquiry_type: enquiryType,
        liveButtonInfo: { btnContent: getContent(data) },
        channelButtonInfos: channelData.map((v) => ({
          ...v,
          button_text: getContent(v),
        })),
      },
    };
  },

  [REPLY_TYPE.ORDER_WITH_CONFIRMATION]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '' },
    req,
    isHistory,
  ) => {
    const extraInfo = dialogue.message_extra || {};
    const { order_id, order_status, image, title, order_status_desc, total_price } = extraInfo.order || {};
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderWithConfirmation,
      data: {
        id: order_id,
        status: order_status,
        image,
        title,
        statusText: order_status_desc,
        totalPrice: total_price,
        isHistory,
        extraInfo,
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_MESSAGE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_text || {};
    const taskbotInfo = data?.task_bot_info || {};
    const buttons = (data.buttons || [])?.map((btn) => {
      // 对于 1001 这种卡片类型，在与后端交互的时候，要传 button_id 给后端，用于在 TFE 上拼接路径
      // 但是 1002 不传，两种卡片都使用的是 TFEMessage，所以在这里对于参数进行处理
      if (btn.action?.task_bot_action) {
        btn.action.task_bot_action.button_id = btn.button_id;
      }
      if (btn.multiple_action?.task_bot_action) {
        btn.multiple_action.task_bot_action.button_id = btn.button_id;
      }
      return btn;
    });

    if (!data.content && (!data.buttons || data.buttons?.length === 0)) {
      return;
    }

    const newUiType = data.ui_type === TFEMessageUIType.new;
    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      displayDirectly: newUiType,
      from: 'bot',
      type: newUiType ? 'TFESystemMessage' : 'TFEMessage',
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        content: data.content,
        jumpNodeMap: data.jump_node_map,
        msgType: data.msg_type,
        // isBypass: data
        haveMinWidth: buttons?.length || checkHaveAccordion(data.content),
        buttonGroup: {
          layout: 'vertical',
          buttons,
        },
        shouldDisplayInstantly: true,
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.TFE_BUTTON_SELECTOR]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_button_selector || {};
    const taskbotInfo = data?.task_bot_info || {};
    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFEMessage',
      showMaxWidth: isBank(),
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        content: data.content,
        className: isBank() ? 'chatbot-bank-selector' : '',
        buttonGroup: {
          layout: isBank() ? 'vertical' : 'horizontal',
          buttons: data.buttons || [],
        },
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.TFE_CARD_SELECTION]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req, isHistory) => {
    const data = dialogue?.message_extra?.task_flow_card || {};
    const taskbotInfo = data?.task_bot_info || {};
    const isSeller = data.user_type === TFEOrderUserType.Seller;

    const statusTabs = {};
    for (const [key, value] of Object.entries(data?.status_text || {})) {
      const displayStatusTabsKey = isSeller ? SELLER_TABS : BUYER_TABS;
      // seller展示的非ALL和return的tab的key需要减去offset值
      const shouldSubOffset
        = isSeller && Number(key) !== TFE_ORDER_VALUE_OF_TABALL && Number(key) !== TFE_ORDER_VALUE_OF_TABRETURN;
      if (displayStatusTabsKey.includes(Number(key))) {
        statusTabs[shouldSubOffset ? key - TFE_ORDER_TABS_SELLER_OFFSET : key] = value;
      }
    }

    let dialogueContent = {};
    switch (dialogue.message_extra.task_flow_card?.card_type) {
      case TFECardSelectionType.ShopeeOrder:
        dialogueContent = {
          nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
          kbBotId: taskbotInfo.bot_id || '',
          tfNodeId: taskbotInfo.tf_node_id || '',
          tfCaseId: taskbotInfo.case_id || '',
          dialogueId: dialogue_id,
          dialogueType: dialogue_type,
          threadNodeId: dialogue?.message_extra?.thread_node_id,
          threadId: dialogue?.message_extra?.thread_id,
          threadIdV2: dialogue?.message_extra?.thread_id_v2,
          roundId: dialogue?.message_extra?.round_id,
          from: 'bot',
          type: 'TFEOrderList',
          data: {
            taskbotInfo,
            id: dialogue?.message?.message_id,
            showMoreOrderButton: data.has_more,
            maxDisplay: data.max_display,
            userType: data.user_type || undefined,
            statusText: data.status_text,
            defaultStatus: data.default_status,
            loadMoreOrderText: data.select_other_content,
            selectOrderText: data.select_content,
            selectAction: data.select_action,
            selectOtherAction: data.select_other_action,
            closeOtherAction: data.close_other_action,
            content: data.order_list,
            tabs: Object.keys(statusTabs).map((key) => ({
              name: statusTabs[Number(key)],
              type: Number(key),
              disabled: data.status.includes(Number(key)) ? false : true,
            })),
            orderCardType: data.order_card_type,
            chatbotComponentType: ChatbotComponentType.ChatbotUI,
            shouldDisplayInstantly: true,
            delayDisplayRecommendIntentSelector:
              !isHistory && isDelayShowIntentSelector(dialogue.message_extra.recommend_display_type),
          },
        };
        break;

      case TFECardSelectionType.FoodDriverOrder:
        dialogueContent = {
          nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
          kbBotId: taskbotInfo.bot_id || '',
          tfNodeId: taskbotInfo.tf_node_id || '',
          tfCaseId: taskbotInfo.case_id || '',
          dialogueId: dialogue_id,
          dialogueType: dialogue_type,
          threadNodeId: dialogue?.message_extra?.thread_node_id,
          threadId: dialogue?.message_extra?.thread_id,
          threadIdV2: dialogue?.message_extra?.thread_id_v2,
          roundId: dialogue?.message_extra?.round_id,
          from: 'bot',
          type: 'OrderSelector',
          data: {
            taskbotInfo,
            useingInTFE: true,
            orderType: OrderType.food,
            id: dialogue?.message?.message_id,
            selectAction: data.select_action,
            text: getTrans(CHECK_ANOTHER_ORDER_TEXT),
            panelTitleText: getTrans(MY_ORDER_TEXT),
            btn: {
              text_value: getTrans(CLICK_HERE_TEXT),
              callback_params: { query_type: OrderSelectorQueryOrderType.DriverTFE },
              button_type: OrderSelectorButtonType.Link,
            },
          },
        };
        break;

      default:
        dialogueContent = {
          nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
          kbBotId: taskbotInfo.bot_id || '',
          tfNodeId: taskbotInfo.tf_node_id || '',
          tfCaseId: taskbotInfo.case_id || '',
          dialogueId: dialogue_id,
          dialogueType: dialogue_type,
          threadNodeId: dialogue?.message_extra?.thread_node_id,
          threadId: dialogue?.message_extra?.thread_id,
          threadIdV2: dialogue?.message_extra?.thread_id_v2,
          roundId: dialogue?.message_extra?.round_id,
          from: 'bot',
          type: 'TFETransactionList',
          data: {
            taskbotInfo,
            id: dialogue?.message?.message_id,
            hasMoreTransaction: data.has_more,
            maxDisplay: data.max_display,
            type: data.card_type,
            loadMoreTransactionText: data.select_other_content,
            selectTransactionText: data.select_content,
            selectAction: data.select_action,
            statusText: data.status_text,
            selectOtherAction: data.select_other_action,
            content: data.transaction_list,
            stillNotFoundContent: data.still_not_found_content,
            checkHereContent: data.check_here_content,
            stillNotFoundAction: data.still_not_found_action,
            transactionContent: data.transaction_not_found_content,
          },
        };
    }

    return dialogueContent;
  },
  [REPLY_TYPE.TFE_RELATED_INTENT]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_related_intent || {};
    const taskbotInfo = data?.task_bot_info || {};
    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFERelatedIntent',
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        content: data.content,
        intents: data.intents || [],
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.TFE_MODAL]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_popup || {};
    const taskbotInfo = data?.task_bot_info || {};
    return {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFEModal',
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        title: data.title,
        content: data.content,
        buttons: [data.left_button, data.right_button],
        jumpNodeMap: data.jump_node_map,
      },
    };
  },
  [REPLY_TYPE.TFE_OPTION_SELECTOR]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_option_selector || {};
    const taskbotInfo = data?.task_bot_info || {};
    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFEOptionSelector',
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        content: data.content,
        options: data.options || [],
      },
    };

    return dialogueContent;
  },
  [REPLY_TYPE.TFE_ARTICLE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_article || {};
    const taskbotInfo = data?.task_bot_info || {};
    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: DIALOGUE_TYPE.TFEArticle,
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        title: data.article_title,
        content: data.content,
        article_number: data.article_number,
        kb_bot_id: data.bot_id,
        kb_intent_id: data.intent_id,
        kb_edition: data.edition,
        kb_answer_id: data.answer_id,
        needOpen: featureToggle.getFeatureEnable(FEATURE_TOGGLE_TYPE.UI_OPTIMISATION_ARTICLE) && featureToggle.getFeatureEnable(FEATURE_TOGGLE_TYPE.UI_OPTIMISATION_ARTICLE_AUTO_POPUP),
        shouldDisplayInstantly: data.should_display_instantly,
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_ORDER_TIP_MSG]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_click_text_reply || {};
    const taskbotInfo = data?.task_bot_info || {};
    const button = data?.button || {};

    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderTipMsg,
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        isTFE: true,
        content: data?.content,
        button: {
          ...button,
          text_value: button?.button_text,
          button_id: button?.button_id,
          button_type: button?.button_type,
        },
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_ORDER_SELECTION_FAQ]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_faq_list_reply || {};
    const taskbotInfo = data?.task_bot_info || {};
    const title = data?.content;
    const listTitle = data?.options_title;
    const options = data?.options || [];

    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: DIALOGUE_TYPE.OrderSelectionFAQ,
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        isTFE: true,
        title,
        listTitle,
        displayNum: data?.max_display,
        showMoreButton: {
          ...data?.show_more_button,
          text_value: data?.show_more_button?.button_text,
          text_value: data?.show_more_button?.button_text,
        },
        listItems: options.map((item) => {
          const { option_id, content, action } = item;
          const params = action?.task_bot_action?.params;

          return {
            button_id: option_id,
            button_text: content,
            intent_id: params?.selected_intent_id?.int_val, // 用于上报
            source_intent_id: params?.source_intent_id?.int_val,
            action,
          };
        }),
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_EPOD_IMAGE]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_image || {};
    const taskbotInfo = data?.task_bot_info || {};

    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFEImage',
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        src: data.url,
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_TIMELINE_CARD]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_timeline_card_reply || {};
    const taskbotInfo = data?.task_bot_info || {};

    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFETimelineCard',
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        title: {
          content: data.title,
          jumpNodeMap: data.jump_node_map,
          msgType: data.msg_type,
        },
        milestones: (data.milestones ?? []).map((v) => ({
          title: v.title,
          dateText: v.date_content,
          hintText: v.extra_info,
          isFuture: v.is_future,
          description: {
            content: v.description,
            jumpNodeMap: v.jump_node_map,
            buttonGroup: {
              layout: 'vertical',
              buttons: v.buttons,
            },
          },
        })),
        buttonGroup: {
          layout: 'vertical',
          buttons: data.buttons,
        },
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_CONTACT_COURIER_CARD]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    console.log({ dialogue_id, dialogue_type, dialogue, node_point_id }, req, '>>>');
    const data = dialogue?.message_extra?.task_flow_key_courier_card || {};
    const taskbotInfo = data?.task_bot_info || {};
    const orderInfoForders = data?.tracking_order?.order_info?.forders ?? [];
    const orderInfoFordersTrackInfo = orderInfoForders?.[0]?.tracking_info ?? [];
    const driverInfo = orderInfoFordersTrackInfo?.[0] ?? {};

    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFEContactCourierCard',
      data: {
        courierTitle: data?.title,
        logoImg: data?.logo?.content,
        trackLinks: data?.links ?? [],
        contactsInfo: data?.contacts_info ?? {},
        driverInfo,
        orderInfo: data?.order_info,
        operateTime: data?.operate_time,
        showDriverInfo: data?.show_driver_info,
        webformButton: data?.webform_button,
        version: data?.courier_ui,
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_BUYER_ORDER]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_food_buyer_order_card || {};
    const taskbotInfo = data?.task_bot_info || {};
    const orderDetail = data?.order_brief || {};

    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFEFoodBuyerOrder',
      data: {
        image: orderDetail?.[0]?.store_logo,
        title: orderDetail?.[0]?.store_name,
        total_price: orderDetail?.[0]?.total_amount,
        create_time: orderDetail?.[0]?.place_time,
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_BUYER_ORDER_LIST]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue?.message_extra?.task_flow_food_buyer_order_card_selector || {};
    const taskbotInfo = data?.task_bot_info || {};
    const dialogueContent = {
      nodePointId: `${taskbotInfo.bot_id || ''}__${taskbotInfo.tf_node_id || ''}__${taskbotInfo.case_id || ''}`,
      kbBotId: taskbotInfo.bot_id || '',
      tfNodeId: taskbotInfo.tf_node_id || '',
      tfCaseId: taskbotInfo.case_id || '',
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      threadNodeId: dialogue?.message_extra?.thread_node_id,
      threadId: dialogue?.message_extra?.thread_id,
      threadIdV2: dialogue?.message_extra?.thread_id_v2,
      roundId: dialogue?.message_extra?.round_id,
      from: 'bot',
      type: 'TFEMessage',
      data: {
        taskbotInfo,
        id: dialogue?.message?.message_id,
        content: data.title,
        buttonGroup: {
          layout: 'horizontal',
          buttons: data.buttons || [],
        },
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.CASE_CARD]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const uriKey = dialogue?.message_extra?.uri_key;
    const uriExtra = dialogue?.message_extra?.uri_extra || {};
    const caseTrackerData = dialogue?.message_extra?.case_tracker_item || {};
    const buttons = dialogue?.message_extra?.buttons_for_general || [];
    const { userType, enquiryType } = coreStore.safeGetStore('agentStore');

    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.CaseCard,
      data: {
        caseTrackerData: {
          ...caseTrackerData,
          uriKey,
          uriExtra,
        },
        buttons,
        liveButtonInfo: {
          userType,
          enquiryType,
        },
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.PROBING_FORM_PREVIEW]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const probingForm = dialogue?.message_extra?.probing_form || {};

    return {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.ProbingFormPreview,
      data: { probingForm },
    };
  },

  [REPLY_TYPE.BASED_ACTION_HANDLE]: (
    { dialogue_id, dialogue_type, dialogue, node_point_id = '', customCallback = {}},
    req,
    isHistory,
  ) => {
    const extra = dialogue?.message_extra;
    import('@/components/ChatbotUI/BasedActionHandle').then(({ default: BasedActionHandle }) => {
      BasedActionHandle({
        extra,
        isHistory,
        dialogueId: dialogue_id,
        dialogueType: dialogue_type,
        nodePointId: node_point_id,
        customCallback,
      });
    });
    return null;
    // 这里本来考虑 使用 hook 但是 考虑到 hook 会执行多次 所以改用调用 普通函数即可
  },

  [REPLY_TYPE.EXPEDITE_DELIVERY_CARD]: ({ dialogue_id, dialogue_type, dialogue, node_point_id = '' }, req) => {
    const data = dialogue.message_extra.task_flow_expedite_delivery_card || {};
    const dialogueContent = {
      nodePointId: node_point_id,
      dialogueId: dialogue_id,
      dialogueType: dialogue_type,
      from: 'bot',
      type: DIALOGUE_TYPE.TFEExpediteDeliverySuccessCard,
      data: {
        id: dialogue?.message?.message_id,
        haveMinWidth: true,
        title: data.title,
        keyMessage: data.key_message,
        additionalMessage: data.additional_message,
        order: data.order,
        taskBotInfo: data?.task_bot_info,
      },
    };

    return dialogueContent;
  },

  [REPLY_TYPE.TFE_MULTIPLE_WEBFORM_NEW_API]: () => {
    return null;
  },

  // ATTENTION: 新增渲染类型要记得 liveHandler(进线的时候给客服发送历史消息) 同步补充
  // ATTENTION2: 历史消息中是否需要额外处理
  // ATTENTION3: TFE 的卡片需要在 data 中存 taskbotInfo，会用来上报信息
};
